import { useEffect } from "react";
import { useHistory } from "react-router";
import { useI18nContext } from "@hopper-b2b/i18n";
import { B2BLoadingPopup } from "@hopper-b2b/ui";

import config from "../../utils/config";
import "./styles.scss";
import { PATH_FLIGHTS_SEARCH } from "../../utils/urlPaths";

export enum LandingPageType {
  FLIGHTS = "flights",
}

export interface MobileLandingPageProps {
  type: LandingPageType;
}

export const MobileLandingPage = ({ type }: MobileLandingPageProps) => {
  const { t } = useI18nContext();
  const history = useHistory();

  useEffect(() => {
    window.parent.postMessage(
      {
        type: "FINISH_SESSION",
        payload: null,
      },
      config.UBER_URL
    );
    history.replace(PATH_FLIGHTS_SEARCH);
  }, []);

  return (
    <B2BLoadingPopup
      open
      message={t("loading")}
      popupSize={"mobile"}
      fullScreen
    />
  );
};
